import React from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';

const ModalHeader = ({ children, style }) => {
  return (
    <Row style={{ borderBottom: '1px solid #ccc' }}>
      <Col>
        <h1 className="modal-header__text" style={style}>
          {children}
        </h1>
      </Col>
    </Row>
  );
};

export default ModalHeader;
